import { Injectable } from '@angular/core';
import { getProgressApi, safeApiCall } from '../utils/api/openapi-utils';
import { ProgressReport } from '../utils/commonTypes';

@Injectable({
  providedIn: 'root'
})
export class ProgressService {

  public async reportModuleProgress(productId: string, moduleId: string, contentId: string, groupId?:string):Promise<boolean> {
    const progressApi = await getProgressApi();
    
    const data = await safeApiCall('reportProgress', () =>
      progressApi.reportProgress({
         reportProgressRequest:{
          productId: productId,
          moduleId: moduleId,
          contentId: contentId,
          groupId: groupId?groupId:undefined,
        }
      })
    );
    return data?true:false;
  }

  public async loadProgress(productId:string): Promise<ProgressReport|null> {
    const progressApi = await getProgressApi();

    const data = await safeApiCall('getProgressReport', () =>
      progressApi.getProgressReport({productId: productId})
    );
    if(!data){
      return null;
    }else{return data;}
  }  
}

